<template>
  <svg
    width="106"
    height="114"
    viewBox="0 0 106 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.828125" y="3.08105" width="104.743" height="102.179" fill="#D3D3D3" />

    <path
      d="M0.828125 103.497L0.828479 110.042L8.24613 113.355L15.7917 110.042L23.2093 113.355L30.7549 110.042L38.1726 113.355L45.7181 110.042L53.1357 113.355L60.6813 110.042L68.0989 113.355L75.6445 110.042L83.0621 113.355L90.6077 110.042L98.0253 113.355L105.571 110.042L105.571 103.497H0.828125Z"
      fill="#D3D3D3"
    />

    <path
      d="M0.828125 9.8584L0.828479 3.31343L8.24613 0.000253677L15.7917 3.31343L23.2093 0.000253677L30.7549 3.31343L38.1726 0.000253677L45.7181 3.31343L53.1357 0.000253677L60.6813 3.31343L68.0989 0.000253677L75.6445 3.31343L83.0621 0.000253677L90.6077 3.31343L98.0253 0.000253677L105.571 3.31343L105.571 9.8584H0.828125Z"
      fill="#D3D3D3"
    />

    <path d="M7.94238 18.0225H43" stroke="#5C5C5C" stroke-width="0.94858" />

    <path
      d="M48 17.6528L51.5964 21.0225L58 15.0225"
      stroke="#5C5C5C"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <path d="M63 18.0225H98.0576" stroke="#5C5C5C" stroke-width="0.94858" />

    <path d="M7.94238 32.0557L98.0274 32.289" stroke="#5C5C5C" stroke-width="0.94858" />

    <path d="M7.94238 44.8984L98.0274 45.1318" stroke="#5C5C5C" stroke-width="0.94858" />

    <path d="M7.94238 57.7422H63.2963" stroke="#5C5C5C" stroke-width="0.94858" />

    <path d="M7.94238 70.3525H89.6736" stroke="#5C5C5C" stroke-width="0.94858" />

    <path d="M7.94238 82.9629L98.0274 83.1963" stroke="#5C5C5C" stroke-width="0.94858" />

    <path d="M7.94238 95.8057H83.8617" stroke="#5C5C5C" stroke-width="0.94858" />
  </svg>
</template>
